import { faCircleArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { generateNavigationPaths } from './navPaths';
import './adminBreadCrumb.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useState } from 'react';
const AdminBreadCrumb = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let [navPaths, setNavPaths] = useState(generateNavigationPaths(''));

  const currentCandidate = useSelector((state) => state.candidateNavigation) || '';
  useEffect(() => setNavPaths(generateNavigationPaths(currentCandidate)), [currentCandidate]);
  useEffect(() => console.log('NAV PATH CHANGED', navPaths), [navPaths]);

  const handleBack = () => {
    const pathname = location.pathname;

    if (pathname === '/candidate/candidate-personal-info') {
      sessionStorage.setItem('fromCandidateInfo', 'true');

      // const savedPagination = sessionStorage.getItem('candidatePagination-listing');
      // if (savedPagination) {
      //   sessionStorage.setItem('restorePagination', 'true');
      // }
      let tableKey = 'listing';
      if (document.referrer.includes('/candidate/unapproved')) {
        tableKey = 'unapproved';
      }

      const savedPagination = sessionStorage.getItem(`candidatePagination-${tableKey}`);
      if (savedPagination) {
        sessionStorage.setItem('restorePagination', 'true');
        sessionStorage.setItem(`candidatePagination-${tableKey}`, savedPagination);
      }

    }


    if (pathname.startsWith('/candidate')) {
      let prevPath = sessionStorage.getItem('prevCandidateListPath');
      console.log('[Breadcrumb] Back nav using prev path:', prevPath);

      if (prevPath?.startsWith('http')) {
        try {
          prevPath = new URL(prevPath).pathname;
        } catch (e) {
          prevPath = '/';
        }
      }
      if (prevPath) {
        navigate(prevPath, { replace: true });
        return;
      }
    }

    navigate(-1);
  };


  return (
    <Row style={{ padding: 24 }}>
      <Col>
        <span>
          <a rel="button" className="signiteButton" onClick={handleBack}>
            <FontAwesomeIcon icon={faCircleArrowLeft} size="sm" /> <span>Back</span>
          </a>
        </span>
        <span className="breadCrumb">
          {_.get(navPaths, location.pathname)
            ?.filter((obj) => Object.keys(obj.label).length !== 0)
            .map((path) => (
              <span className={`bc ${path.class}`}>{path.label}</span>
            ))}
        </span>
      </Col>
    </Row>
  );
};
export default AdminBreadCrumb;